import axios from 'axios';
import apiConfig from '../../api.config';

export default function getHardCheckinValues({ hotelId,}) {
  const {
    host,
    URIs: { pmsGetHardCheckinValues },
  } = apiConfig;

  const uri = `${host}${pmsGetHardCheckinValues}`.replace(':hotelId', hotelId);

  return axios
    .get(uri, {
    })
    .then(res => {
      return res.data;
    });
}
